import { Dialog } from "construct-ui";
import FileUploadInputComponent from "../../../components/file/file-upload-input.component";
import { FILE_EXTENSIONS } from "../../../config/constants";
import UserChannelMappingModel from "../../../models/user-channel-mapping/user-channel-mapping.model";
import ViewBase from "../../view-base.view";

/**
 * User Channel Mapping- Excel Upload Dialog
 * 
 * The upload dialog used to download excel template and upload records to delete or update
 * 
 * @author cmcnkhiep(Ryan)
 */

export default function UserChannelMappingUploadDialog() {
  ViewBase.call(this);

  const FORM_ID = 'userChannelMappingExcelUploadForm';
  const UPLOAD_INPUT_ID = 'userChannelMappingExcelUploadInput';

  let file = null
  let onResultChange = (id) => { };
  let handleCloseDialog = () => { };

  const downloadPurchaseOrdersExcelFormat = () => {
    this.showLoading();
    UserChannelMappingModel.downloadTemplateSiteManaged()
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  };

  const upload = (e) => {
    // Form validation
    if (!this.validateForm(e)) {
      return false;
    }

    this.showLoading();
    UserChannelMappingModel.exportUserChannelMapping(file)
      .then((result) => {
        this.showMessage(this.getText('EM00000313', 'Upload Completed'), this.getText('EM00000004', 'Success'), () => {
          onResultChange(result);
          handleCloseDialog();
        })
      })
      .catch((error) => {
        this.handleError(error);
        form.reset();
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  return {
    oninit: (vnode) => {
      if (vnode.attrs.onResultChange)
        onResultChange = vnode.attrs.onResultChange;
    },
    view: ({ attrs: { filters, isOpen, onClose } }) => {
      handleCloseDialog = onClose;
      return m(Dialog,
        {
          isOpen,
          onClose,
          class: 'cui-dialog-l',
          title: this.getText('LT00000761', 'Batch Upload approval'),
          content: m('container',
            m('ol',
              m('li.fw-bold.mb-4',
                m('.mb-2', this.getText('LT00000018', 'Excel Download')),
                m('button.btn.btn-primary',
                  {
                    onclick: () => { downloadPurchaseOrdersExcelFormat(filters); }
                  },
                  m('i.bi.bi-file-earmark-arrow-down-fill'),
                  this.getText('LT00000218', 'Download Template')
                ),
              ),
              m('hr'),
              m('li.fw-bold.mb-4',
                m('.mb-2.mandatory', this.getText('LT00000197', 'Excel Upload')),
                m('form.row.g-4.needs-validation[novalidate]', { id: FORM_ID, onsubmit: upload },
                  m('.col-12.position-relative',
                    m(FileUploadInputComponent, {
                      id: UPLOAD_INPUT_ID,
                      accept: FILE_EXTENSIONS.XLSX,
                      required: true,
                      onInput: (data) => { file = data; },
                    }),
                    m('.invalid-tooltip', this.getText('EM00000316', 'Please select a file'))
                  )
                ),
              )
            ),
            this.getBaseViews()
          ),
          footer: m('.d-flex.gap-2.justify-content-end',
            m('button.btn.btn-primary[type="submit"]', { form: FORM_ID }, this.getText("LT00000290", "Upload")),
            m('button.btn.btn-white', { onclick: onClose }, this.getText("LT00000021", "Close"))
          )
        }
      );
    }
  }
}
